<div class="container-fluid flex column gap-10px">
  @if (typeVisible) {
  <div class="flex row-collapse">
    <label class="col-sm-6 control-label">
      {{ 'benefits.benefit-mgt.benefit-flag.benefit-type' | translate | titlecase }}
    </label>
    <div class="col-sm-6">
      <select [(ngModel)]="benefitFlag.BenefitTypeId" required class="form-control">
        <option *ngFor="let benefit of benefitTypes" [value]="benefit.Id"
          [selected]="benefit.Id == benefitFlag.BenefitTypeId ? true : null">
          {{ benefit.Name }}
        </option>
      </select>
    </div>
  </div>
  }
  <div class="flex row-collapse">
    <label class="col-sm-6 control-label">
      {{ 'benefits.benefit-mgt.benefit-flag.quantity-used' | translate | titlecase }}
    </label>
    <div class="col-sm-6">
      <input [(ngModel)]="benefitFlag.QuantityUsed" required type="number" class="form-control"
        (ngModelChange)="onQuantityChange($event)" />
    </div>
  </div>
  <div class="flex row-collapse">
    <label class="col-sm-6 control-label">
      {{ 'benefits.benefit-mgt.benefit-flag.amount-used' | translate | titlecase }}
    </label>
    <div class="col-sm-6">
      <div class="input-group">
        <wl-currency-symbol class="input-group-addon"></wl-currency-symbol><input [(ngModel)]="benefitFlag.AmountUsed"
          required type="number" class="form-control" />
      </div>
    </div>
  </div>
</div>
